<template>
    <div class="top">
        <div class="top_image">
            <img src="@/assets/topimage1.jpg">
            <h1>Emotion Diary</h1>
            <p>Simple Everywhere Feeling</p>
        </div>
        <p style="text-align:center;margin:30px;font-size:1.3em;font-wight:bold;">普段の日記からあなたの感情を管理しよう。感情トラッキング日記サービス「エモーションダイアリー」の3つの魅力</p>
        <div class="columns">
            <div class="column">
                <img src="@/assets/topimage4.png">
            </div>
            <div class="column" style="margin:10%;">
                <h2>Simple</h2>
                <p>エモーションダイアリーは、月額500円のシンプルで高機能な感情トラッキング日記サービスです。</p>
                <p>あなたがすることは今の気持ちや感じたことを日記に書いて自己評価を記入するだけ。</p>
                <p>あなたの評価に加えて、感情分析による文章全体のポジティブ度の測定と感情の分類が行なわれます。</p>
                <p>自分が行う感情評価と機械が行う感情評価の二つの方法により、内と外（主観と客観）の両面からあなたの感情を把握するお手伝いをします。</p>
                <p>最初の1ヶ月はお試し期間で無料です。</p>
            </div>
        </div>
        <div class="columns" style="background-color:#ECF3F1">
            <div class="column" style="margin:10%;">
                <h2>Everywhere</h2>
                <p>パソコン（PC）・スマホ・Mac・iPad等、どのデバイスでも執筆ができます。</p>
                <p>データはオンラインで管理されるので機種を変えてもデータは引き継がれます。</p>
            </div>
            <div class="column">
                <img src="@/assets/topimage6.png">
            </div>
        </div>
        <div class="columns" style="">
            <div class="column is-3" style="margin:10%;">
                <h2>Feeling</h2>
                <p>ノーシェア。</p>
                <p>エモーションダイアリーはブログやSNSのようなシェア機能をつけていません。</p>
                <p>自分のためだけの時間です。感じるままに執筆しましょう。</p>
            </div>
            <div class="column">
                <img src="@/assets/topimage3.png">
            </div>
        </div>
                <div style="text-align:center;font-size:1.5em;font-weight:bold">Let's Start</div>
        <div v-if="!userStatus" style="text-align:center;font-size:1.5em"><router-link to="login"><i class="fas fa-sign-in-alt"></i> ログインして始める</router-link></div>
    </div>
</template>

<script>
export default {
    computed: {
        userStatus() {
            return this.$store.getters.isSignIn;
        }
    },
    mounted(){
        const title = "感情トラッキング日記サービス｜エモーションダイアリー"
        const description = "自分の文章から感情の把握（トラッキング）ができるプライベートオンライン日記。パソコン（PC）・iPad・スマホで簡単管理。AIによる文章分析で日々の感情を客観的に把握できます。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    }   
}
</script>

<style scoped>
.top_image {
  position: relative;
}
h2{
    font-weight: bold;
    font-size: 1.2em;
}
.columns{
    margin-top:20px;
}
.top_image h1 {
    position: absolute;
    color: white;/*文字は白に*/
    font-weight: bold; /*太字に*/
    font-size: 1.8em;/*サイズ2倍*/
    font-weight: bold;
    top: 0;
    left: 0;
    margin:10px;
    padding:0;
    z-index: 1;
  }
.top_image p {
    position: absolute;
    top: 14%;
    left:0;
    margin:20px;
    padding:0;
    color: white;/*文字は白に*/
    font-weight: bold; /*太字に*/
    font-size: 1.3em;/*サイズ2倍*/
    font-weight: bold;
    z-index: 1;
  }
.top_image img {
  width: 100%;
  }
.top_image::after{
	/* 透過した黒を重ねる */
	background-color: rgba(0,0,0,0.3);
	/* どの範囲に重ねるかを指定 */
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
    margin:0;
    padding:0;
	content: ' ';
}
</style>


